import { mutations } from './mutations';
import { actions } from './actions';
import { Module } from 'vuex';
import feedbackStoreState from './state';
import { TFeedbackStore } from '../types';
import { RootState } from '@/store';

export default function (): Module<TFeedbackStore, RootState> {
  return {
    namespaced: true,
    state: feedbackStoreState,
    mutations,
    actions,
  };
}
